import * as locationTypes from '../types/locationTypes';

export const applyLocation = (location) => {
    return {
        type: locationTypes.APPLY_LOCATION,
        payload: location
    };
};